export default "__VITE_ASSET__3a393217__"